import React, { useState, useEffect } from "react";
import { useNotification } from '../../../hooks/useNotification';
import FormControlLabel from "@mui/material/FormControlLabel";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useDataAuth } from '../../../hooks/useDataAuth';
import Typography from '@mui/material/Typography';
import FormGroup from "@mui/material/FormGroup";
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Switch from "@mui/material/Switch";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { createContact, getStateUser, updateUserStatusWhatsApp } from '../../../services/whatsApp.service';
import { PhoneNumberInput } from '../../others/PhoneNumberInputManual';
import { ActionButtons } from '../../others/ActionButtons';
import { Dialog } from '../../others/Dialog';
export const CreateNewContact = ({ idCompany, fetchContacts }) => {
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();

    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [code, setCode] = useState('+57');
    const [number, setNumber] = useState('');
    const [userState, setUserState] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setName('');
        setCode('+57');
        setNumber('');
    };

    const handleSave = async () => {
        if (name === '' || number === '') {
            sendNotification({
                msg: 'Complete todos los campos obligatorios',
                variant: 'error',
            });
            return;
        }
        const response = await createContact(userSession.token, { id_company: idCompany, name, cellphone: `${code.replace("+", '')}${number}` });
        // console.log("response", response);
        if (response && response.data && Array.isArray(response.data)) {
            const result = response.data[0];
            if (result?.id_marketing_whatsapp && !result?.result) {
                sendNotification({
                    msg: 'Contacto creado correctamente',
                    variant: 'success',
                });
                fetchContacts()
            } else if (result?.id_marketing_whatsapp && result?.result) {
                sendNotification({
                    msg: `El contacto ya existe: ${result.result}`,
                    variant: 'error',
                });
                return;
            } else {
                sendNotification({
                    msg: 'Error inesperado al crear el contacto',
                    variant: 'error',
                });
                return;
            }

        }
        handleClose();
    };

    const handleChange = () => setUserState(!userState);

    const handleBlur = async () => {
        try {
            updateUserStatusWhatsApp(userSession.token, userState ? "1" : "0");    
        } catch (error) {
            console.log("error updating status user", error)
        }
        
    }

    useEffect(() => {
        const fetchStateUser = async () => {
            try {
                const response = await getStateUser(userSession.token);
                if (response?.data?.[0]?.status_whatsapp) 
                    setUserState(Number(response.data[0].status_whatsapp) === 1 ? true : false);
            } catch (error) {
                console.error("Error fetching state user:", error);
            }
        };
        fetchStateUser();
    }, [userSession.token]);


    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    py: 1,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#202c33' },
                }}
            >
                <Box display="flex" alignItems="center">
                    <Avatar sx={{ bgcolor: '#25D366', width: 36, height: 36 }} onClick={handleOpen}>
                        <PersonAddIcon />
                    </Avatar>
                    <Typography
                        variant="body1"
                        sx={{ color: 'white', ml: 2, fontWeight: 500 }}
                    >
                        Nuevo contacto
                    </Typography>
                </Box>

                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={userState}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                color="#141616ff"
                            />
                        }
                        label=""
                    />
                </FormGroup>
            </Box>

            <Dialog
                openDialog={open}
                title="Crear nuevo contacto"
                styleTitle={{ fontWeight: 'bold', color: 'white' }}
                styleDialog={{ backgroundColor: '#111b21', color: 'white' }}
                content={
                    <Stack spacing={2} mt={1}>
                        <TextField fullWidth placeholder="Nombre" variant="outlined" sx={{ border: '1px solid #4b5563' }}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            InputProps={{ style: { color: 'white' } }}
                        />
                        <PhoneNumberInput code={code} setCode={setCode} number={number} setNumber={setNumber} />
                    </Stack>
                }
                actions={
                    <ActionButtons
                        onCancel={handleClose}
                        onSubmit={handleSave}
                        submitLabel={'Guardar'}
                    />
                }
                styleActions={{ margin: '10px 16px' }}
            />
        </>
    );
};
